import { Component, ElementRef, Input, OnDestroy, ViewChild, HostListener, ChangeDetectionStrategy, OnInit, HostBinding } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { controlPopupPosition } from 'src/app/functions';
import { fade } from 'src/app/animations';
import Subscriber from 'src/app/subscriber';

const sub = new Subscriber();

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  animations: [fade()],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent implements OnInit, OnDestroy {
  // ! do not move delay to animations
  @Input() delayShow: number = 300;

  @Input() delayHide: number = 500;

  /** defines the offset in `px` from the screen edges to resize the tooltip */
  @Input() set offsetX(offsetX: number) {
    this.maxWidth = `calc(100vw - ${offsetX * 2}px)`;
    this._offsetX = offsetX;
  };

  get offsetX(): number {
    return this._offsetX;
  }

  private _offsetX = 38;

  @HostBinding('style.max-width') maxWidth = `calc(100vw - ${this.offsetX * 2}px)`;
  @HostBinding('style.padding') padding = 'unset';
  @HostBinding('style.box-shadow') boxShadow = 'unset';
  @HostBinding('style.background') background = 'unset';

  @ViewChild('container') containerRef: ElementRef<HTMLElement>;

  set active(status: boolean) {
    if (this._active.value !== status) {
      this._active.next(status);
      this._onActiveChange();
    }
  }

  get active() {
    return this._active.value;
  }

  private _active = new BehaviorSubject(false);

  public activeObservable = this._active.asObservable();

  private _timeoutId?: number;

  constructor() {}

  ngOnInit() {
    let resizeTimer: number;

    const onResize = () => {
      // * fixing position on resize
      clearTimeout(resizeTimer);

      resizeTimer = window.setTimeout(() => this._controlPosition());
    }

    // * event listeners
    window.addEventListener('resize', onResize);

    sub.on.once(Subscriber.events.unsubscribe, () => {
      window.removeEventListener('resize', onResize);
    })

    // sub.push()
  }

  ngOnDestroy() {
    sub.unsubscribe();
  }

  public show(
    delay: number = this.delayShow,
  ) {
    this._clearTimeout();

    if (!this.active) {
      this._timeoutId = window.setTimeout(() => {
        delete this._timeoutId;
        this.active = true;
      }, delay);
    }
  }

  public hide(
    delay: number = this.delayHide,
  ) {
    this._clearTimeout();

    if (this.active) {
      this._timeoutId = window.setTimeout(() => {
        delete this._timeoutId;
        this.active = false;
      }, delay);
    }
  }

  private _clearTimeout(): void {
    window.clearTimeout(this._timeoutId);
    delete this._timeoutId;
  }

  private _controlPosition() {
    if (this.active) {
      const containerEl = this.containerRef && this.containerRef.nativeElement
      const wrapEl = containerEl && containerEl.parentElement

      if (wrapEl)
        controlPopupPosition(wrapEl, this.offsetX)
    }
  }

  private _onActiveChange() {
    if (this.active) {
      setTimeout(() => this._controlPosition());
      this.padding = undefined;
      this.boxShadow = undefined;
      this.background = undefined;
    } else {
      this.padding = 'unset';
      this.boxShadow = 'unset';
      this.background = 'unset';
    }
  }

  @HostListener('mouseenter')
  private _onMouseenter(): void {
    this.show();
  }

  @HostListener('mouseleave')
  private _onMouseleave(): void {
    this.hide();
  }
}
